// extracted by mini-css-extract-plugin
export default {"heading":"SecurityPriorityPage_heading__EFUj5","contentHeading":"SecurityPriorityPage_contentHeading__3Xwnh","content":"SecurityPriorityPage_content__zjB54"};